import { ChainID } from '@ankr.com/chains-list';

import { ChainPageLoader } from 'modules/chains/components/ChainPageLoader';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { PrivateAAPIPageContent } from './components/PrivateAAPIPageContent';
import { PublicAAPIPageContent } from './components/PublicAAPIPageContent';

export const AdvancedApiPage = () => {
  const { isLoggedIn } = useAuth();

  const Component = isLoggedIn ? PrivateAAPIPageContent : PublicAAPIPageContent;

  return <ChainPageLoader Component={Component} chainID={ChainID.MULTICHAIN} />;
};
